import {
  dispatch,
  embedFiles,
  getShowOnboardingModalSignup,
  getWorkspace,
  logOut,
  TrackEventType,
  updateShowOnboardingDialogSignup,
  useAppSelector,
  useCreateZoFileObjectsMutation,
  useEmbedFileMutation,
  useGetIndexingStatusMutation,
  useLogoutMutation,
  finService,
  useListZoFilePrefixesMutation,
  getToken,
  getRefreshToken,
} from '@zonofi/seller-rtk-store';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { SIGNUP_ONBOARDING } from '../navigation';
import { useNavigate } from 'react-router-dom';
import { useSetupCentrifugo } from '@zonofi/chats-common/hooks/setup-centrifugo';
import { SimulatorScreenEnum } from './enum';
import { isEmpty } from 'lodash';
import { getConfigValue } from '@zonofi/common/functions/get-config-value/get-config-value';

export const useSignupOnboardingScreen = () => {
  const navigate = useNavigate();
  const workspace = useAppSelector(getWorkspace);
  const showOnboardingDialog = useAppSelector(getShowOnboardingModalSignup);

  const encodedData = localStorage.getItem('authData');
  const baseUrl = getConfigValue('APP_ENDPOINT');

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const isPollingRef = useRef<boolean>(false);

  const [files, setFiles] = useState<File[]>([]);
  const [viewFile, setViewFile] = useState<boolean>(false);
  const [embedFilesObj, setEmbedFilesObj] = useState<embedFiles[]>([]);
  const [msgText, setMsgText] = useState<string>('');
  const [s3Keys, setS3Keys] = useState<string[]>([]);
  const [showWelcomeModal, setShowWelcomeModal] = useState<boolean>(true);
  const [showAgentReadyModal, setShowAgentReadyModal] =
    useState<boolean>(false);
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [zonoMoneyUrl, setZonoMoneyUrl] = useState<string>('');
  const [showErrorStrip, setShowErrorStrip] = useState<boolean>(false);
  const [simulatorScreen, setSimulatorScreen] = useState<SimulatorScreenEnum>(
    SimulatorScreenEnum.WHATSAPP
  );
  const [isSampleFileLoadError, setIsSampleFileLoadError] =
    useState<boolean>(false);

  const [fetchFilesReq, fetchFilesRes] = useListZoFilePrefixesMutation();
  const [uploadFilesReq, uploadFilesRes] = useCreateZoFileObjectsMutation();
  const [embedFilesReq, embedFilesRes] = useEmbedFileMutation();
  const [getIndexingStatusReq, getIndexingStatusRes] =
    useGetIndexingStatusMutation();

  const [logoutApi] = useLogoutMutation();
  useSetupCentrifugo();

  const fileUrl = useMemo(() => {
    const fileName = `${workspace?.industry}.txt`;
    const fileUrl = `https://zotok-marketing.s3.ap-south-1.amazonaws.com/bot-traning-files/${fileName}`;

    return fileUrl;
  }, [workspace?.industry]);

  const changeToZonoMoneySimulator = (url: string) => {
    const separator = url.includes('?') ? '&' : '?';
    setZonoMoneyUrl(`${url}${separator}isSimulation=true`);
    setSimulatorScreen(SimulatorScreenEnum.ZONOMONEY);
  };

  const fetchFiles = () => {
    fetchFilesReq({
      params: {
        sellerWorkspaceId: workspace?.id || '',
      },
      body: {
        documentType: 'knowledge',
      },
    });
  };

  const cleanupPolling = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    isPollingRef.current = false;
  }, []);

  const testAIAgent = () => {
    finService.trackEvent(TrackEventType.SIGNUP_TEST_STARTED);
    fetchFiles();
    setShowAgentReadyModal(false);
    dispatch(updateShowOnboardingDialogSignup(false));
  };

  const extractS3Info = (presignedUrl: string) => {
    const url = new URL(presignedUrl);
    const hostParts = url.hostname.split('.');
    const bucket = hostParts[0];
    const key = url.pathname.startsWith('/')
      ? url.pathname.slice(1)
      : url.pathname;
    return { bucket, key };
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        return;
      } else {
        e.preventDefault();
        // if (!isEmpty(msgText.trim())) {
        //   sendWhatsappMessage();
        // }
      }
    }
  };

  const viewSampleFile = () => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const content = e.target?.result as string;
      navigate(SIGNUP_ONBOARDING.VIEW_SAMPLE_FILE.path, {
        state: { fileContent: content },
      });
    };

    reader.onerror = () => {
      alert('Error reading file');
    };

    reader.readAsText(files[0]);
  };

  const logoutUser = () => {
    navigate('/login');
    logoutApi();
    dispatch(logOut());
  };

  const navigateToRetrainScreen = () => {
    navigate(SIGNUP_ONBOARDING.RETRAIN_AGENT.path);
  };
  const token = useAppSelector(getToken);
  const refreshToken = useAppSelector(getRefreshToken);

  const navigateToLaunchScreen = () => {
    const isMobile =
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
      window.innerWidth <= 768;
    if (isMobile) {
      navigate(SIGNUP_ONBOARDING.SIGNUP_LAUNCH.path);
    } else if (encodedData) {
      const decodedData = atob(encodedData);
      const decodedDataObj = JSON.parse(decodedData);
      decodedDataObj.token = token;
      decodedDataObj.refreshToken = refreshToken;
      decodedDataObj.userRoles = ['adm'];
      const newEncodedData = btoa(JSON.stringify(decodedDataObj));
      window.location.href = `${baseUrl}/login?data=${newEncodedData}`;
    }
  };

  const navigateToSignupHome = () => {
    navigate(SIGNUP_ONBOARDING.SIGNUP_HOME.path);
  };

  const closeConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const openConfirmationModal = () => {
    setShowConfirmationModal(true);
  };

  const sendWhatsappMessage = () => {
    //write logic to send whatsapp message through mock api
  };

  const startTrainingPolling = useCallback(() => {
    if (isPollingRef.current) {
      console.log('Polling already in progress, skipping...');
      return;
    }

    cleanupPolling();

    const pollApi = () => {
      if (!isPollingRef.current) return;

      getIndexingStatusReq({
        params: { sellerWorkspaceId: workspace?.id },
        body: { s3Keys },
      });
    };

    if (s3Keys.length > 0 && workspace?.id) {
      console.log('Starting polling...', { s3Keys });
      isPollingRef.current = true;

      pollApi();

      intervalRef.current = setInterval(pollApi, 3000);

      timeoutRef.current = setTimeout(() => {
        console.log('Polling timeout reached');
        cleanupPolling();
        setShowWelcomeModal(false);
        setShowAgentReadyModal(true);
      }, 10000);
    } else {
      console.log('No s3Keys or workspace, skipping to ready modal');
      setShowWelcomeModal(false);
      setShowAgentReadyModal(true);
    }
  }, [s3Keys, workspace?.id, getIndexingStatusReq, cleanupPolling]);

  const fetchSampleFile = async (): Promise<File> => {
    const fileName = `${workspace?.industry}.txt`;
    const response = await fetch(fileUrl);
    if (!response.ok) {
      setIsSampleFileLoadError(true);
      throw new Error('Failed to fetch sample file');
    }
    const blob = await response.blob();

    return new File([blob], fileName, { type: 'text/plain' });
  };

  const getSampleFile = async () => {
    try {
      const file = await fetchSampleFile();
      setFiles([file]);
    } catch (err) {
      console.error('Error loading sample file:', err);
      setIsSampleFileLoadError(true);
    }
  };

  const trainWithSampleFile = async () => {
    try {
      const file = await fetchSampleFile();
      setFiles([file]);

      const uploadReq = [
        {
          name: file.name,
          suffix: file.name,
          documentType: 'knowledge',
          type: 'file',
        },
      ];

      uploadFilesReq({
        params: { sellerWorkspaceId: workspace?.id },
        body: { uploadReq },
      });
    } catch (err) {
      console.error('Error loading sample file:', err);
    }
  };

  useEffect(() => {
    return () => {
      cleanupPolling();
    };
  }, [cleanupPolling]);

  useEffect(() => {
    if (workspace?.id) {
      getSampleFile();
      fetchFiles();
      if (showOnboardingDialog) {
        trainWithSampleFile();
      }
    }
  }, [workspace?.id]);

  useEffect(() => {
    if (fetchFilesRes?.isSuccess && fetchFilesRes?.data) {
      const filteredFiles = fetchFilesRes?.data?.data?.files?.filter(
        (item) => item?.name !== 'readMe.txt'
      );
      setShowErrorStrip(isEmpty(filteredFiles));
    }
  }, [fetchFilesRes]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'BACK_TO_WHATSAPP_CLICKED') {
        if (event.data?.payload?.goBackToWhatsapp) {
          setSimulatorScreen(SimulatorScreenEnum.WHATSAPP);
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    if (uploadFilesRes?.isSuccess && uploadFilesRes?.data && files.length > 0) {
      const data = uploadFilesRes.data.data || [];
      const keys: string[] = [];
      const extractedObjects: embedFiles[] = [];

      Promise.all(
        data.map((item, index) => {
          const file = files[index];
          const object = extractS3Info(item?.presignedUrl);
          keys.push(object.key);
          extractedObjects.push(object);

          return fetch(item.presignedUrl, {
            method: 'PUT',
            body: file,
            headers: { 'Content-Type': file.type },
          }).then((res) => {
            if (!res.ok) throw new Error('Failed to upload file to S3');
          });
        })
      )
        .then(() => {
          setEmbedFilesObj(extractedObjects);
          setS3Keys(keys);
        })
        .catch((err) => console.error('S3 upload error:', err));
    }
  }, [uploadFilesRes, files]);

  useEffect(() => {
    if (embedFilesObj.length > 0) {
      setShowWelcomeModal(true);
      setShowAgentReadyModal(false);
      embedFilesReq({
        params: { sellerWorkspaceId: workspace?.id },
        files: embedFilesObj,
      });
    }
  }, [embedFilesObj, embedFilesReq, workspace?.id]);

  useEffect(() => {
    if (embedFilesRes?.isSuccess) {
      startTrainingPolling();
    } else if (embedFilesRes?.isError) {
      cleanupPolling(); // Clean up on error
      setShowWelcomeModal(false);
    }
  }, [embedFilesRes, startTrainingPolling, cleanupPolling]);

  useEffect(() => {
    if (getIndexingStatusRes?.isSuccess && getIndexingStatusRes?.data) {
      const allIndexed = getIndexingStatusRes.data.data.every((item) =>
        item.tags.some((tag) => tag.Key === 'indexed' && tag.Value === 'true')
      );

      if (allIndexed) {
        console.log('All files indexed, stopping polling');
        cleanupPolling();
        setShowWelcomeModal(false);
        setShowAgentReadyModal(true);
      }
    }
  }, [getIndexingStatusRes, cleanupPolling]);

  return {
    changeToZonoMoneySimulator,
    closeConfirmationModal,
    handleKeyDown,
    isSampleFileLoadError,
    logoutUser,
    msgText,
    navigateToLaunchScreen,
    navigateToRetrainScreen,
    navigateToSignupHome,
    openConfirmationModal,
    sendWhatsappMessage,
    setIsSampleFileLoadError,
    setMsgText,
    setSimulatorScreen,
    setViewFile,
    setZonoMoneyUrl,
    showAgentReadyModal,
    showConfirmationModal,
    showErrorStrip,
    showOnboardingDialog,
    showWelcomeModal,
    simulatorScreen,
    testAIAgent,
    trainWithSampleFile,
    viewFile,
    viewSampleFile,
    zonoMoneyUrl,
  };
};
